import { filter } from "lodash";

const ImageLinks = {
  phone_contact: require("./icons/phone_contact.svg").default,
  chevron_right: require("./icons/chevron_right.svg").default,
  map_marked: require("./icons/map_marked.svg").default,
  carbon_location_filled: require("./icons/carbon_location_filled.svg").default,
  pidge_white_logo: require("./pidge_white_logo.svg").default,
  pidge_gray_logo: require("./pidge_gray_logo.svg").default,
  address_book: require("./icons/address_book.svg").default,
  arrow_right_filled: require("./icons/arrow_right_filled.svg").default,
  bx_wallet: require("./icons/bx_wallet.svg").default,
  bxs_package: require("./icons/bxs_package.svg").default,
  eva_calendar_outline: require("./icons/eva_calendar_outline.svg").default,
  message: require("./icons/message.svg").default,
  icons_user: require("./icons/icons_user.svg").default,
  round_track_changes: require("./icons/round_track_changes.svg").default,
  search_purple: require("./icons/search_purple.svg").default,
  chevron_right_purple: require("./icons/chevron_right_purple.svg").default,
  chevron_left: require("./icons/chevron-left.svg").default,
  clock: require("./icons/clock.svg").default,
  arrow_right_filled_circle: require("./icons/arrow-right-filled-circle.svg")
    .default,
  rider: require("./icons/rider.svg").default,
  arrow_left_fillef_black: require("./icons/arrow_left_fillef_black.svg")
    .default,
  copy: require("./icons/copy.svg").default,
  time_clock: require("./icons/time_clock.svg").default,
  poc: require("./icons/poc.svg").default,
  call_circle: require("./icons/call_circle.svg").default,
  share: require("./icons/share.svg").default,
  ellipse_filled_purple: require("./icons/ellipse_filled_purple.svg").default,
  ellipse_purple: require("./icons/ellipse_purple.svg").default,
  vector_40: require("./icons/vector_40.svg").default,
  location_1: require("./icons/location_1.svg").default,
  chevron_right_white: require("./icons/chevron_right_white.svg").default,
  drop: require("./icons/drop.svg").default,
  fluent_payment: require("./icons/fluent_payment.svg").default,
  bx_wallet_purple: require("./icons/bx_wallet_purple.svg").default,
  check_tick_filled: require("./check_tick_filled.svg").default,
  ellips_success: require("./ellipse_success.svg").default,
  ellips_payment_failed: require("./icons/ellipse_payment_failed.svg").default,
  icon_cross_red: require("./icons/icon_cross_red.svg").default,
  edit_sky_blue: require("./icons/edit_sky_blue.svg").default,
  dot_sky_blue: require("./icons/dot_sky_blue.svg").default,
  add_purple: require("./icons/add_purple.svg").default,
  chevron_down_blue: require("./icons/chevron_down_blue.svg").default,
  calender_blue: require("./icons/calender_blue.svg").default,
  arrow_right_circle_blue: require("./icons/arrow_right_circle_blue.svg")
    .default,
  close: require("./icons/close.svg").default,
  motor_racing_helmet: require("./icons/motor_racing_helmet.svg").default,
  menu_dots: require("./icons/menu_dots.svg").default,
  delete_red: require("./icons/delete_red.svg").default,
  home_icon: require("./icons/home_icon.svg").default,
  cross_circle_filled: require("./icons/cross_circle_filled.svg").default,
  bin_black: require("./icons/bin_black.svg").default,
  add_circle_light_purple: require("./icons/add_circle_light_purple.svg")
    .default,
  radio_fill: require("./icons/radio_fill.svg").default,
  radio: require("./icons/radio.svg").default,
  ellips_not_assign: require("./icons/Eelipse_not_assign.svg").default,
  info_light_yellow: require("./icons/info_light_yellow.svg").default,
  default_profile: require("./profile.svg").default,
  help: require("./icons/help.svg").default,
  question_mark_circle: require("./icons/question_mark_circle.svg").default,
  info_circle_black: require("./icons/info_circle_black.svg").default,
  no_internet: require("./icons/no_internet.svg").default,
  geo_pin: require("./icons/geo_pin.svg").default,
  cureent_location: require("./icons/current_location.svg").default,
  paytm_logo: require("./paytm_logo.svg").default,
  info_circle_red: require("./icons/info_circle_red.svg").default,
  info_gray: require("./icons/info_gray.svg").default,
  edit_purple: require("./icons/edit_purple.svg").default,
  filter: require("./icons/filter.svg").default,
  chevron_down: require("./icons/chevron_down.svg").default,
  chevron_up: require("./icons/chevron_up.svg").default,
  receipt: require("./icons/receipt.svg").default,
  check: require("./icons/ci_checkbox-check.svg").default,
  pickup: require("./icons/pickup.svg").default,
};

export default ImageLinks;
